import { Box, Stack } from "@mui/material";

import { Skeleton } from "@/components/ui-v2";

export const PrimaryNavigationContentLoader = () => (
  <Box sx={{ p: 2 }}>
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      <Skeleton variant="rectangular" width="70%" height={40} />
      <Skeleton variant="rectangular" width="20%" height={40} />
    </Box>
    <Stack spacing={2} sx={{ mt: 2 }}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Skeleton variant="rectangular" width="100%" height={32} key={index} />
      ))}
    </Stack>
  </Box>
);
